export default {
    name: '이름',
    headers:{
        dashBoard:'대쉬보드',
        market:'마켓',
        liquidation:'청산',
        larix:'LARIX',
        Positions:'직위',
        stake:'스테이크',
        dao:'DAO',
        connect:'연결',
        About:'About',
        reward:'보상',
        launchpad:'Launchpad',
        main:'Main Pool'
    },
    reward:{
        larixBalance:'LARIX 잔고',
        larixRewards:'LARIX 보상',
        mSOLReward:'mSOL 보상',
        insufficientUsdcBalance:'Insufficient USDC balance',
        stake:'말뚝',
        stakeForLP:'LP 생성을 위한 스테이크',
        earn2x:'{x}X LARIX 보상을 얻기 위한 지분',
        claimDirectly:'클레임 ',
        myStaking: '내 스테이킹',
        seeDetails: '자세히보다',
        youWillLose1: '지금 신청하면 {x} LARIX 보상 를',
        youWillLose2: '추가로 획득할 수 있는 기회를 잃게 됩니다',
        reward:'보상',
        walletBalance:'* 지갑 잔액 :',
        maximumReceive:'MAX 클레임 가능 {x} LARIX',
        expiredReward:'락업 기간 후 보상',
        days:'일',
        currentRewards:'현재 보상',
        stakeTime:'락업 기간',
        claimLARIX:'Claim LARIX',
        needUSDC:'Estimated USDC ≈',
        chooseToReceive:'Choose to receive',
        main:"Main",
    },
    wallet:{
        reward:'보상',
        connect:'연결',
        faucet:'파우셋',
        connectToAWallet:'지갑으로 연결',
        yourWallet:'지갑',
        disconnect:'연결해제',
        connected:'연결됨',
        harvest:'지금 청구하세요',
        walletBalance: '지갑 잔액',
        unclaimedBalance: '청구 가능한 보상',
        price: 'LARIX가격',
        nothingToClaim: '청구할 것이 없음',
        subAccount :'My position',
        recentTransactions : '최근 거래',
        wallet : '지갑'
    },
    footer:{
        doc:'문서'
    },
    home:{
        totalSupply:'총 공급',
        totalBorrow:'총 대여',
        totalMined:'총 채굴양',
        larixPrice:'Larix 가격',
        supplyMarket:'공급 시장',
        borrowMarket:'대여 시장',
        myBill:'나의 계산서',
        asset:'자산',
        collateral:'담보',
        allMarket:'모든 시장',
        supplyAPY:'공급 APR',
        wallet:'지갑',
        borrowAPY:"대여 APR",
        liquidity:"유동성",
        operation:"작업",
        borrowBalance:"대여 잔액",
        supplyBalance:"공급 잔액",
        withdraw:"인출",
        repay:"재지불",
        supply:"공급",
        borrow:"대여",
        loading:"로딩",
        connectToAWallet:'지갑에 연결',
        liquidityMining:'유동성 채굴',
        totalAPR:'총 APR',
        more:'더',
        pool:'캐피탈 풀',
        raydiumLP:'Raydium LP',
        unsettledAssets:'미정 자산',
        handleTip:'Transaction undone, please click here to process >',
        singleAsset:'단일 자산',
        myPosition:'내 위치',
        tip:'힌트',
        noBorrowFee:'대출 수수료 없음',
    },
    supplyAndBorrow:{
        borrowLimit:"대여 한도",
        netAPY:"순 APR",
        borrowBalance:"대여 잔액",
        supplyBalance:"공급 잔액",
        netValue:'순가치',
        borrowRatio:'차입비율',
    },
    supplyDialog: {
        supply: "공급",
        withDraw: "인출",
        wallet: "지갑",
        balance: "잔액",
        walletBalance: "지갑잔액",
        liquidity: "유동성",
        max: "최대",
        limit85: "85% 제한",
        supplyApy: "공급 APR",
        supplyBalance: "공급 잔액",
        borrowLimit: "대여 제한",
        supplyRate: "공급 비율",
        withdrawRate: "인출 비율",
        invalidNumber:"유효하지 않은 번호",
        insufficientLiquidity:"유동성 부족",
        stillWithdraw:"인출 강행",
        borrowLimitUsedPercent:"대여 한도 활용 비율",
        collateralFactor:"담보 요소",
        insufficientFunds:"자금 부족",
        solBalanceIsLow:'SOL 낮은 균형',
        cancel:'취소',
        interestRate: "이율",
        miningAPY: "채굴 APR",
        supplyMaxLimit100M:"최대 공급량은 {x} 달러로 제한된다",
        currentSupply:"Current supply amount is",
        reachLpLimit:"Reach LP deposit Limit",
        reachLimit:"Reach deposit Limit",
        baseReward:'기본 보상',
        boostedAPR:'부스트된 LARIX APR',
        APR:'APR',
        supplyMaxAPR:'Max APR',
        baseAPR:'Base APR',
        baseLARIXRewards:'Base LARIX rewards',
        borrowingMinAPR:'Min APR',
    },
    borrowDialog: {
        borrow: "대여",
        repay: "재지불",
        wallet: "지갑",
        balance: "잔액",
        walletBalance: "지갑",
        liquidity: "유동성",
        borrowMax: "대여 최대",
        max:'최대',
        borrowApy: "대여 APR",
        borrowBalance: "대여 잔액",
        borrowLimit: "대여 한도",
        borrowRate: "대여 비율",
        repayRate: "재지불 비율",
        borrowMaxInTokenUnit:"최대로 대여",
        borrowLimitUsedPercent:"대여 한도 활용 비율",
        collateralFactor:"담보 요소",
        invalidNumber:"유효하지 않은 번호",
        insufficientLiquidity:"유동성 부족",
        stillBorrow:"인출 강행",
        noBalanceToRepay:"재지불에 필요한 잔액 부족",
        insufficientFunds:"불충분한 자금",
        cancel:'취소',
        interestRate: "이율",
        miningAPY: "채굴 APR",
        reachPositionLimit:'각 계정은 동시에 총 5개의 담보 및 차입 상호 작용으로 제한됩니다.',
    },
    market:{
        supply:"공급",
        borrow:"대여",
        top3Markets:"Top 3 마켓",
        asset:"자산",
        totalSupply:"총 공급",
        supplyAPY:"공급 APR",
        totalBorrow:"총 대여",
        borrowAPY:"대여 APR",
        details:"세부사항",
        supplyBorrow:'총 시장 가치',
        loading:"로딩",
        connectToAWallet:'지갑에 연결',
        totalSupplyApy:"총 공급/APR",
        totalBorrowApy:"총 대여/APR",
        depositLimit:"입금 한도",
        supplyIR:'공급 비율',
        borrowIR:'대여 비율',
        supplyDistributionAPR:'공급 분배 APR',
        borrowDistributionAPR:'대여 분배 APR',
        supplyIRHelpContext:'Supply APR = 공급 비율 + 공급 채굴 APR',
        borrowIRHelpContext:'Borrow APR = 대여 비율 - 대여 채굴 APR',
        stake:'Stake',
        swap:'Swap',
    },
    marketId:{
        market:"시장",
        supply:"공급",
        borrow:"대여",
        netRate:"순 APR",
        supplyAPY:"공급 APR",
        distributionSupplyAPY:"분배 APR",
        distributionBorrowAPY:"분배 APR",
        totalSupply:"총 공급",
        borrowAPY:"대여 APR",
        totalBorrow:"총 대여",
        interestRateModel:"이율 모델",
        marketDetails:"시장 세부사항",
        Price:"가격",
        marketLiquidity:"시장 유동성",
        collateralFactor:"담보 요소",
        exchangeRate:"교환 비율",
        supplyMiningAPR:"공급 채굴 APR",
        borrowMiningAPR:"대여 채굴 APR",
        utilization:"활용",
        supplyChartAPY:"공급 APR",
        borrowChartAPY:"대여 APR",
        mndeAPR:"APR"
    },
    larix:{
        amountinCirculation:"유통 총량",
        circulatingMarketCap:"유통 마켓캡",
        totalSupply:"총량",
        lARIXDistribution:"LARIX 분배",
        market:"시장",
        perDay:"일일 채굴",
        supplyMiningAPR:"공급 채굴 APR",
        borrowMiningAPR:"대여 채굴 APR",
        dailyDistribution:"일일 분배",
        other:"다른",
        distribution:"분배",
        larixPrice:'Larix 가격',
    },
    About:{
        aboutLarix:"Larix에 대해",
        aboutLarixContext:"Larix는 Solana에 대한 최초의 Metaverse 기반 금융 프로토콜입니다, 다양한 담보 유형, 암호화폐 토큰, 스테이블코인, 합성자산, NFT 등 다양한 자본 효율적인 관리 풀을 만들어 안전한 방식으로 완전히 활용할 수 있습니다.",
        auditReport:"감사 보고소",
        whyLarix:"왜 Larix인가",
        reason1:"라이브 마이닝 기능을 갖춘 최초의 대여 프로토콜",
        reason2:"대여 프로토콜 최초로 P2P 대여 방식의 NFT를 지원 할 것 입니다.",
        reason3:"이 최초의 대여프로토콜은 솔라나 위에서 적으로 오픈소스되었습니다.",
        roadmap:"로드맵",
        roadmapStep1:"Phase 1: 7월 – 9월 2021",
        roadmapStep2:"Phase 2: 2021년 말 -  2022",
        roadmapStep3:"Phase 3: 2022년 이후",
        roadmapStep1Context:"Larix는 자동화된 Defi 대출의 필수적인 요구를 충족시키는 것부터 시작합니다. 이 단계에서 암호화폐 토큰, 스테이블코인, 합성자산 등이 담보물로 받아들여집니다. 리스크 관리와 자산보안이 라릭스의 초석입니다.",
        roadmapStep2Context:"PYT 네트워크와 제휴하여 높은 충실도(HiFi) 금융 시장을 더 넓은 범위의 기존 금융 자산의 자본 활용도를 높일 수 있는 분산형 금융(Defi)의 세계에 연결합니다.",
        roadmapStep3Context:"이 프로토콜은 모든 자산 클래스에 걸쳐 피어 투 피어 대출을 통해 NFT(Non-Fungible Token)를 받아들이도록 담보 기반을 확장합니다. Larix는 여러 파트너와 협력하여 실물 경제에 안전하고 커스터마이징 가능하며 거의 즉각적인 유동성을 제공할 것입니다.",
        seedRoundInvestor:"우리의 투자자 ",
        partnership:"파트너쉽",
        audit:"감사",
    },
    liquidation: {
        liquidation : '청산',
        liquidateTips : '청산 팁',
        account: '계좌',
        amountTip: '재지불하기 원하는 총금액',
        assetToRepay :'재지불하기 위한 자산',
        assetsToRepay :'재지불하기 위한 자산',
        maxRepayAmount: '재지불 최대 금액',
        assetToSeize : '압류해야할 자산',
        assetsToSeize : '압류해야할 자산',
        maxSeizeAmount : '최대 압류 금액',
        debtRatio : '부채 비율',
        action : '조치',
        liquidate : '청산',
    },
    noticeDialog: {
        notice : '공지',
        text : '채굴 시작을 위한 카운트다운',
        confirm: '확정'
    },
    pendingDialog: {
        transactionPending: "펜딩",
        viewOnEtherscan: "Heco에서 보기",
        confirm: "거래 확정...",
        broadcast: "거래 브로드케스트...",
        waitingEvm: "EVM 결과 대기...",
        errorTips:"거래 실패",
        checkTips:"성공적인 거래"
    },
    handleLpDialog:{
        unsettledAssets:'미정 자산',
        withdraw:'인출',
        keepMining:'채굴 계속',
        tooltip:'처리할 주문을 선택하세요'
    },
    openObligationDialog:{
        openChoose:'하위 계정 열기 또는 선택',
        usable:'사용 가능한 하위 계정:',
        unavailable:'사용 가능한 하위 계정이 없습니다',
        rulesLine1:'* lp 담보 규정:',
        rulesLine2:'하위 계정은 하나의 LP 자산만 담보할 수 있습니다',
        action:'새 계정 및 담보 개설',
    },
    borrowFeeTipDialog:{
        tip:'힌트',
        noBorrowFee:'Larix에는 대출 수수료가 없습니다',
        gotIt:'알았어요',
    },
    larixStakingDialog:{
        expireDate:'Expire date',
        stakedLP:'스테이킹된 LP',
        assets:'자산',
        amount:'양',
        unlockingTime:'잠금 해제 시간',
        stakeTime:'Locked Date',
        actions:'행위',
        unlocking:'Unlocking',
        oneClickClaim:'Claim LARIX rewards from Raydium',
        claim:'Claim',
        raydiumReward:'Raydium 보상',
    },
    tip:{
        borrowLimitTip:'대출 한도는 대출할 수 있는 자산의 최대 금액입니다. 이것은 주황색 막대로 표시됩니다. 공급된 자산의 가치가 높을수록 차입 한도가 높아집니다',
        borrowBalanceTip:'차입 잔액은 모든 차용 자산의 합계입니다',
        supplyBalanceTip:'공급 잔액은 공급된 모든 자산의 합계입니다. 예금을 늘리면 대출 한도가 증가할 수 있습니다',
        netAPRTip:'순 연이율 = 총 연간 수익률 / 순 가치 (총 연간 수익률 = 총 공급 수익률 - 총 차입 비용)',
        netValueTip:'순 가치=공급 잔액-차입 잔액',
        borrowRatioTip:'차입비율 = 총차입금 / 공급잔액. 차입율은 자산의 가동률을 반영하며 상한선은 차입금 한도입니다',
        liquidationTip:'계정이 청산을 트리거할 때의 총 차입 금액입니다. 이는 빨간색 막대로 표시됩니다. 총 차입금 => 청산 임계값일 때 계정은 청산 가능한 상태가 됩니다. 예금을 늘리거나 차입금을 줄이면 계정이 청산되지 않을 수 있습니다',
        supplyAPRTip:'자산 공급에 대해 획득한 연간 비율(APR)입니다. APR은 동적이며 풀의 총 공급이 증가/감소함에 따라 변동합니다.공급 APR = 공급 이자(공급된 자산의 수익률) + 공급 채굴 수익률(LARIX 토큰)',
        borrowAPRTip:'차용 자산에 대해 지불하는 연이율(APR)입니다. APR은 동적이며 풀의 총 차입 자금이 증가/감소함에 따라 변동합니다.차입 APR = 차입이자(특정 토큰 차용 비용) - 차입 채굴 수익률(LARIX 토큰)',
        walletBalanceTip:'지갑 잔액은 지갑에 있는 다양한 자산의 잔액입니다. 지갑 잔액은 빌린 자산 및 해당 이자를 공급하거나 상환하는 데 사용할 수 있습니다',
        liquidityTip:'유동성은 출금/차입이 가능한 자산의 현재 잔고입니다. 풍부한 유동성은 또한 언제든지 예금을 인출할 수 있다는 것을 의미합니다',
        borrowFeeTip:'Larix는 \'대출 수수료 제로\' 정책을 가지고 있습니다. 대출 수수료는 대출 시 추가 비용으로 차입이자와는 다릅니다. 대출 수수료 = 대출 금액 * 대출 수수료율. 대출 금액이 많을수록 대출 수수료율이 높아져 대출 수수료가 높아집니다. 거래가 이루어질 때마다 대출 수수료가 부과됩니다',
        collateralTip:'입금 후 담보 버튼을 켜야 대출이 가능합니다. 자산의 스테이킹 가치가 높을수록 빌릴 수 있는 금액(즉, 차입 한도)이 높아집니다',
        availableTip:'사용 가능은 현재 최대 대출 가능 자산입니다',
        myRewardTip:'Larix에서 단일 토큰을 공급/차입하거나 LP를 스테이크하면 채굴 수익률(LARIX 토큰)을 얻을 수 있습니다. 여기에서 공급/차입 채굴 수익률입니다',
        myStakeTip:'x5/x10 부스트 보상을 선택했을 때 Raydium에 스테이킹된 LARIX/USDC LP의 양입니다',
        lockedDateTip:'잠금 날짜는 x5/x10 부스트 보상을 선택하고 LARIX/USDC LP를 스테이킹하는 날짜입니다. 락업 기간(90일 또는 180일) 동안 스테이킹된 LARIX/USDC LP를 출금할 수 없습니다',
        unlockingDateTip:'잠금 해제 시간은 90일/180일의 스테이킹 후 5x/10x LARIX 부스트 보상을 청구하고 LP를 잠금 해제할 수 있는 날짜입니다',
        stakeAmountTip:'금액는 x5/x10 부스트 보상을 선택하고 스테이킹한 LARIX/USDC LP의 수량입니다',
        raydiumRewardTip:'x5/x10 부스트 보상을 선택하고 LARIX/USDC 유동성을 추가하면 유동성 채굴에 대한 LARIX 보상을 받게 되며, 잠금 기간 없이 언제든지 Larix에서 청구할 수 있습니다. "클레임" 버튼을 클릭하기만 하면 됩니다. 모두 수확합니다. 보상 중 RAY 부분은 Raydium에서 유동성을 제거한 후 지갑으로 전송됩니다',
        dailyTip:'일일 채굴은 자산의 공급 및 차입으로 얻은 LARIX 토큰의 일일 양입니다',
        collateralFactorTip:'담보 단위의 최대 대부 자산 비율. 예를 들어, $100 상당의 USDC를 제공하고 최대 $85 상당의 BTC를 빌릴 수 있는 경우 USDC 담보 계수는 85%입니다',
        larixRewards:'LARIX 보상',
        dialogAPR1X:'초기의 1X APR',
        dialogAPR5X:'부스트 5X APR',
        APRTip:'Optional boosted APR if LARIX rewards are staked for 10x',
        baseRewardTip:'Receive local currency APR and LARIX APR',
        boostedAPRTip:'Optional boosted APR if LARIX rewards are staked for 5x',
        maxAPRTip:'(10x boosted staking)',
        baseAPRTip:'(Supply APR + LARIX rewards)',
        baseAPRTip2:'(Borrow APR - LARIX rewards)',
        interest:'interest',
        doubleRewardTip:'({x} 보상은 24시간마다 지갑에 직접 지급됩니다)',
        claimStakeRewardTip:'Click any \'Claim\' button to claim all LP rewards (5x and 10x included).  If there\'s still remaining unclaimed rewards, keep clicking \'Claim\' until all rewards are claimed.',
        liquidateTip:'부채 비율이 100%를 초과하면 청산이 발생합니다.',
    },
    positions:{
        mySupply:'내 공급',
        myBorrow:'내 대출',
        myStake:'내 스테이크',
        myReward:'내 보상',
        liquidationThreshol:'청산 기준',
        claim:'주장하다 ',
        noSupplyYet:'아직 공급 없음',
        noBorrowYet:'아직 대출 없음',
        noStakeYet:'아직 지분 없음',
        supplyNow:'지금 공급',
        borrowNow:'지금 빌리기',
        stakeNow:'지금 스테이크',
    },
    launchpad:{
        whatLaunchpad:'Larix 렌딩 런치패드란 무엇입니까?',
        details1:'Larix Lending Launchpad는 기본 SPL 토큰을 위한 별도의 자금 풀을 제공합니다.',
        details2:'Larix는 대출 기능을 실현하기 위해 더 많은 토큰을 지원하기 위해 기존 교차 담보 대출 풀을 기반으로 하는 격리된 펀드 풀을 출시했습니다.',
        details3:'Lending Launchpad에 새로운 자산을 등록하려면 주저하지 말고 신청서를 작성해 주십시오.',
        apply:'적용하다'
    }
}
